function asyncEffect(effect) {
  return () => { effect(); };
}

export default asyncEffect;
